import initLozad from './lozad';

export default class Extensions {
	constructor() {

		this._init();
	}

	_init() {
		initLozad();
	}
}